import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { Http, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';

// ---- COMMON MODULES ---- //
import { Functions } from './functions';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class UserdataModel {
    userdata: any=[];

    constructor(private storage: Storage, public functions: Functions){
        this.getUserdata();
    }

    setUserdata(
        /* --- PROFILE DATA --- */
        guidUser:string,
        username:string,
        email:string,
        password:string,
        fullname:string,
        sex:string,
        education:string,
        birthDate:string,  //"1980-11-04"

        picture:string,
        creationDate:string,
        language:string,
        spokenLanguages:string,
        roles:string,
        lastAccess:string,
        lastLogin:string,
        link:string,
        cancelLink:string,
        
        /* --- GAMEDATA --- */
        score:number,
        level: number,
        collectibles:any,
        booksinfo:any,
        
        /* --- SESSION DATA --- */
        token:string,
        session_name:string,
        sessid:string
        ){
        return new Promise((resolve) =>{
            if(guidUser!="") {this.userdata[0].guidUser=guidUser;}
            if(username!="") {this.userdata[0].username=username;}
            if(email!="") {this.userdata[0].email=email;}
            if(password!="") {this.userdata[0].password=password;}
            if(fullname!="") {this.userdata[0].fullname=fullname;}
            if(sex!="") {this.userdata[0].sex=sex;}
            if(education!="") {this.userdata[0].education=education;}
            if(birthDate!="") {this.userdata[0].birthDate=birthDate;}

            if(picture!="") {this.userdata[0].picture=picture;}
            if(creationDate!="") {this.userdata[0].creationDate=creationDate;}
            if(language!="") {this.userdata[0].language=language;}
            if(spokenLanguages!="") {this.userdata[0].spokenLanguages=spokenLanguages;}
            if(roles!="") {this.userdata[0].roles=roles;}
            if(lastAccess!="") {this.userdata[0].lastAccess=lastAccess;}
            if(lastLogin!="") {this.userdata[0].lastLogin=lastLogin;}
            if(link!="") {this.userdata[0].link=link;}
            if(cancelLink!="") {this.userdata[0].cancelLink=cancelLink;}

            if(score!=-1) {this.userdata[0].score=score;}
            if(level!=-1) {this.userdata[0].level=level;}
            if(collectibles!="") {this.userdata[0].collectibles=collectibles;}
            if(booksinfo!="") {this.userdata[0].booksinfo=booksinfo;}

            if(token!="") {this.userdata[0].token=token;}
            if(session_name!="") {this.userdata[0].session_name=session_name;}
            if(sessid!="") {this.userdata[0].sessid=sessid;}
            
            this.storeUserdata().then((response)=>{
                resolve("UserDataStored");
            });
        });
    }

    clearUserdata(){
        return new Promise((resolve) =>{
            this.userdata=[];
            this.userdata.push({});
            this.storeUserdata().then((response)=>{
                resolve("storeUserdataOk");
            });
        });
    }

    storeUserdata(){
        return new Promise((resolve) =>{
        this.storage.set('userdata', JSON.stringify(this.userdata)).then((response)=>{
            resolve("UserDataStoredLocally");
          });
        });
    }

    getUserdata(){
        this.storage.get('userdata').then((userdata) => {
            if(userdata){
                this.userdata=JSON.parse(userdata);
            }else{
                this.userdata.push({});
            }
        });
    }

    isCurrentBookComplete(){
        if(this.getBookmark()>=this.getNumsnttotal()){
            return true;
        }else{
            return false;
        }
    }

    isBookComplete(idBook){
        if(this.getBookmarkofBook(idBook)>=this.getNumsnttotalofBook(idBook)){
            return true;
        }else{
            return false;
        }
    }

    isCurrentBookBeginned(){
        if(this.getBookmark()>0){
            return true;
        }else{
            return false;
        }
        
    }

    /* --------- GETTER/SETTER --------- */
    setGuidUser(guidUser){
        this.userdata[0].guidUser=guidUser;
    };

    getGuidUser(){
        return this.userdata[0].guidUser;
    };

    setScore(score){
        this.userdata[0].score=score;
    };

    getScore(){
        return this.userdata[0].score;
    };

    setLevel(level){
        this.userdata[0].level=level;
    };

    getLevel(){
        return this.userdata[0].level;
    };

    setCollectibles(collectibles){
        this.userdata[0].collectibles=collectibles;
    };

    getCollectibles(){
        return this.userdata[0].collectibles;
    };

    setBooksinfo(booksinfo){
        this.userdata[0].booksinfo=booksinfo;
    };

    getBooksinfo(){
        return this.userdata[0].booksinfo;
    };

    addSkip(numSkip){
        var idBook=this.functions.idCurrentBook;
        this.userdata[0].booksinfo[idBook-1].skip=this.userdata[0].booksinfo[idBook-1].skip+numSkip;
    };

    useSkip(){
        var idBook=this.functions.idCurrentBook;
        this.userdata[0].booksinfo[idBook-1].skip--;
    };

    getSkip(){
        var idBook=this.functions.idCurrentBook;
        return this.userdata[0].booksinfo[idBook-1].skip;
    };

    getLanguageofBook(idBook){
        return this.userdata[0].booksinfo[idBook-1].language;
    };

    getBookmark(){
        var idBook=this.functions.idCurrentBook;
        return parseInt(this.userdata[0].booksinfo[idBook-1].bookmark);
    };

    getBookmarkofBook(idBook){
        return parseInt(this.userdata[0].booksinfo[idBook-1].bookmark);
    };

    getNumsnttotal(){
        var idBook=this.functions.idCurrentBook;
        return parseInt(this.userdata[0].booksinfo[idBook-1].numsnttotal);
    };

    getNumsnttotalofBook(idBook){
        return parseInt(this.userdata[0].booksinfo[idBook-1].numsnttotal);
    };

    setBookmark(bookmark){
        var idBook=this.functions.idCurrentBook;
        this.userdata[0].booksinfo[idBook-1].bookmark=bookmark;
    };
    
    setNumsnttotal(numsnttotal){
        var idBook=this.functions.idCurrentBook;
        this.userdata[0].booksinfo[idBook-1].numsnttotal=numsnttotal;
    };

    /* --------- END --------- GETTER/SETTER --------- */
}


// WEBPACK FOOTER //
// ./src/providers/userdata-model.ts